import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { forwardRef } from "react";
const CustomizedSelect = forwardRef(
  (
    {
      id,
      name,
      label,
      value,
      onChange,
      options,
      disabled,
      error,
      helperText,
      sx,
      color,
      renderValue,
      defaultValue,
      required,
      helperTextSize,
      inputRef,
    },
    ref
  ) => {
    return (
      <FormControl
        size="small"
        fullWidth
        disabled={disabled}
        error={error}
        ref={ref}
        color={color}
      >
        <InputLabel id="demo-simple-select-label" required={required}>
          {label}
        </InputLabel>
        <Select
          id={id}
          error={error}
          name={name}
          value={value}
          label={label}
          onChange={onChange}
          inputRef={inputRef}
          sx={sx}
          size="small"
          renderValue={renderValue}
          defaultValue={defaultValue || ""}
        >
          {options &&
            options.map((option, index) => {
              return (
                <MenuItem value={option.value || option} key={index}>
                  {option.label || option}
                </MenuItem>
              );
            })}
        </Select>
        {helperText && (
          <FormHelperText
            sx={{
              fontSize: helperTextSize,
            }}
          >
            {helperText}
          </FormHelperText>
        )}
      </FormControl>
    );
  }
);

export default CustomizedSelect;
